import { associeradListVy } from '../../../_Common/Components/BusinessCollectionComponents/associeradListVy';
import { IObjektVy } from '../../../../../Types/ObjektVy';
import { objektLänk, standardVy } from '../../../../../Utils/ObjektVyUtils';
import ObjektVySida from '../../../_Common/Components/BusinessCollectionComponents/ObjectVySida';
import { objektVyGrupp } from '../../../_Common/Components/BusinessCollectionComponents/ObjektVyGrupp';

const standard: IObjektVy = standardVy([
  ObjektVySida('standard', [
    [
      objektVyGrupp(
        'first',
        [
          'FIL_PRODDATUM',
          'SkapadUtbetfil',
          'Totalbelopp',
          'AntalFakturor',
          'Anvandare',
          'STATUS_ELEKTRONISK_BETALNING',
          'REDOVISA_PER_GRUPP',
        ],
        ' '
      ),
      objektVyGrupp('second', [objektLänk('Utbetalningsvag')], ' '),
      objektVyGrupp(
        'third',
        [
          associeradListVy('Betalningar', {
            inCard: true,
            noCaption: true,
          }),
        ],
        'Betalningar'
      ),
    ],
  ]),
]);

export const Betalningsuppdragsvyer: IObjektVy[] = [standard];
